import "./FAQ2.css";
import React from 'react';
import { Row, Col, Button, Divider } from 'antd';
import { checkArray } from '../../../../ValidateInput';
import { PlusOutlined, MinusOutlined } from '@ant-design/icons';

class FAQ2 extends React.Component {
    state = {
        FAQOPEN: {}
    }
    render() {
        return (
            <Row justify="center" style={{ backgroundColor: "white" }}>
            <Col xs={23}>
                <Row>
                    <Col xs={24}>
                        <h3 className="Section-Component-Title">Frequently Asked Questions</h3>
                    </Col>
                </Row>
                {
                    checkArray(this.props.FAQ).map((faq, index) => {
                        return (
                            <Row gutter={[20,20]} className="FAQ2-Row">
                                <Col xs={24}>
                                    <Row
                                    justify="space-between"
                                    onClick={() => {
                                        let faqOpen = { ...this.state.FAQOPEN };
                                        let faqState = faqOpen[index] || false;
                                        faqOpen[index] = !faqState;
                                        this.setState({
                                            FAQOPEN: faqOpen,
                                        })
                                    }}
                                    className="FAQ2-Question-Container">
                                        <Col>
                                        <h2 className="FAQ2-Question">{faq.Question}</h2>
                                        </Col>
                                        {
                                            !this.state.FAQOPEN[index] ?
                                            <Col>
                                            <Button
                                                type="text"
                                                icon={<PlusOutlined />}
                                            />
                                            </Col>
                                            :
                                            <Col>
                                            <Button
                                                type="text"
                                                icon={<MinusOutlined />}
                                            />
                                            </Col>
                                        }
                                    </Row>
                                </Col>
                                {
                                    this.state.FAQOPEN[index] ?
                                    <Col xs={24} className="FAQ2-Answer">
                                        <div>
                                            {faq.Answer}
                                        </div>
                                        <Divider />
                                    </Col>
                                    :
                                    null
                                }
                            </Row>
                        )
                    })
                }
            </Col>
            </Row>
        )
    }
}

export default FAQ2;